import React, { useEffect, useState } from "react";
import { query, queryAll, getBaseUrl, checkStickyImage } from "../utils/utils";
import { fetchNavigationData } from "../utils/api";

const MenuPhablet = () => {
  let baseUrl = getBaseUrl();

  // States
  const [isOpen, setIsOpen] = useState(false);
  const [path, setPath] = useState("");
  const [currentNavigation, setCurrentNavigation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [stickyLogo, setStickyLogo] = useState(false);

  /**
   * EXTERNAL TOGGLES
   */
  const pageHeader = query("#page-header");
  const phabletOuter = query("#menu-phablet-outer");
  const phabletToggles = queryAll(".phablet-toggle", pageHeader);

  phabletToggles.forEach((phabletToggle) => {
    phabletToggle.addEventListener("click", (event) => {
      let changeOpen = !isOpen;
      phabletOuter.classList.toggle("active", changeOpen);
      document.body.classList.toggle("has-modal", changeOpen);
      phabletToggles.forEach((phabletToggle) =>
        phabletToggle.setAttribute("aria-expanded", String(changeOpen)),
      );
      if (!changeOpen) {
        // Tween does animation?
        // TODO enable if needed
        // Tween.set(this.$refs.clip, {height: 'auto'})
        setPath("");
      }
      setIsOpen(changeOpen);
    });
  });

  /**
   * Get the new navigation data for a given url.
   *
   * @param {string} url The (base) url to get the navigation information for.
   * @memberof SlwfNavigation
   */
  async function getNavigationData(url) {
    /**
     * Check if the given url has already been processed and is stored in the
     * local state for navigation items.
     * Todo: Add back and make work if everything is done
     const existingNavigation = navigationItems.find((el) => {
      return el["@id"] === navigationId;
    });

     */
    /**
     * If the url has already been processed we set the current navigation item
     * to the existing information.
     *
     * We can assume that the component is used within one request cycle in
     * the frontend. After using this component a new page will be loaded
     * and we get fresh urls.
     */

    /**
     * Indicate that the loading starts.
     */
    setIsLoading(true);
    // Todo Add test if already exits in state and use
    fetchNavigationData(url)
      .then((response) => response.json())
      .then((data) => {
        setCurrentNavigation(data), setIsLoading(false);
      });
  }

  // Fill the state on mount
  useEffect(() => {
    /**
     * Fetch the navigation data.
     */
    if (baseUrl) {
      getNavigationData(baseUrl);
      getStickyLogo(baseUrl);
    }
  }, []);

  const getStickyLogo = async (baseUrl) => {
    /**
     * Return the Sticky Logo url if exits. If not fallback to Mobilelogo
     */
    let jsonData = await checkStickyImage(baseUrl);
    if (jsonData) {
      setStickyLogo(baseUrl + "/@@images/sticky_logo");
    } else {
      setStickyLogo(baseUrl + "/@@images/logo");
    }
  };
  function clickBackLinkHandler(e) {
    if (currentNavigation !== null) {
      if (currentNavigation["parent"]) {
        e.preventDefault();
        getNavigationData(currentNavigation["parent"]);
      }
    }
  }
  /**
   * Render the navigation items.
   *
   * @return {*} JSX code.
   * @memberof SlwfNavigation
   *
   *
   */
  function _renderNavigationItems() {
    let itemStructure = (
      <>
        {currentNavigation?.items.map((item) => {
          let klass = "link-outer d-flex ai-center w-100";
          if (item["@id"] === baseUrl) {
            klass += "inpath";
          }

          let clickHandler;
          let link = item["@id"];
          if (item?.has_children) {
            klass += " has_children";
            clickHandler = (e) => {
              e.preventDefault();
              getNavigationData(item["@id"]);
            };
          }
          return (
            <li
              className="menu-tree-level sans-m1"
              key={item["@id"].toString()}
            >
              {item?.has_children ? (
                <a
                  href={link}
                  onClick={clickHandler}
                  className="link-outer d-flex ai-center w-100"
                >
                  <span>
                    <span className="link-inner">{item.title}</span>
                  </span>
                  <span className="icon icon-s ml-auto" onClick={clickHandler}>
                    <svg>
                      <use href="++theme++dipftheme/images/icons.svg#icon-chevron-right-s"></use>
                    </svg>
                  </span>
                </a>
              ) : (
                <a href={link} className="link-outer d-flex ai-center w-100">
                  <span>
                    <span className="link-inner">{item.title}</span>
                  </span>
                </a>
              )}
            </li>
          );
        })}
      </>
    );

    return itemStructure;
  }
  return (
    <>
      <div id="menu-phablet" className="menu-main frame stack-m fg-lite">
        <div
          className="hold menu-back"
          style={{
            opacity:
              currentNavigation !== null && currentNavigation["parent"]
                ? "unset"
                : "0",
          }}
        >
          <button
            onClick={clickBackLinkHandler}
            tabIndex="-1"
            type="button"
            className="link-outer d-flex ai-center"
          >
            <span className="d-block icon icon-s">
              <svg>
                <use href="/++theme++dipftheme/images/icons.svg#icon-chevron-left-s"></use>
              </svg>
            </span>
            <span className="d-block link-inner ml-xxs">Zurück</span>
          </button>
        </div>
        <div className="menu-clip clip" style={{ height: "auto" }}>
          <div
            className="menu-push flow-s"
            style={{ transform: "translateX(0%)" }}
          >
            <ul
              role="region"
              className="menu-tree-panel stack-xs menu-tree-root"
            >
              {_renderNavigationItems()}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuPhablet;
